"use strict";

var _classCallCheck = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutModes = void 0;

var Modes_1 = require("../../../../Enums/Modes");

var OutModes = /*#__PURE__*/function () {
  function OutModes() {
    _classCallCheck(this, OutModes);

    this.default = Modes_1.OutMode.out;
  }

  _createClass(OutModes, [{
    key: "load",
    value: function load(data) {
      var _a, _b, _c, _d;

      if (!data) {
        return;
      }

      if (data.default !== undefined) {
        this.default = data.default;
      }

      this.bottom = (_a = data.bottom) !== null && _a !== void 0 ? _a : data.default;
      this.left = (_b = data.left) !== null && _b !== void 0 ? _b : data.default;
      this.right = (_c = data.right) !== null && _c !== void 0 ? _c : data.default;
      this.top = (_d = data.top) !== null && _d !== void 0 ? _d : data.default;
    }
  }]);

  return OutModes;
}();

exports.OutModes = OutModes;